import styled, { css } from "styled-components";

export const StyledNumber = styled.label`
  width: 100%;
  max-width: 260px;
  margin: 8px 0;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  > input {
    display: flex;
    height: 38px;
    max-height: 42px;
    padding: 0px 8px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2px;
    align-self: stretch;
    width: 100%;
    border: none;
    border-bottom: 2px solid ${({ theme }) => theme.colors.primarySeparator};
    border-radius: 2px;
    ${({ theme }) => theme.fontStyles.InterfaceCopy}
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    background-color: ${({ theme }) => theme.colors.neutralsWhiteTint85};
    -moz-appearance: textfield;

    &:read-only {
      background-color: ${({ theme }) => theme.colors.disabledInputBackground};

      &:hover,
      &:focus {
        box-shadow: none;
        border-bottom: 2px solid ${({ theme }) => theme.colors.primarySeparator};
      }
    }

    &:hover {
      box-shadow:
        0px 8px 16px 0px rgba(161, 153, 194, 0.2),
        0px 4px 8px 0px rgba(161, 153, 194, 0.16),
        0px 2px 4px 0px rgba(161, 153, 194, 0.12),
        0px 1px 2px 0px rgba(161, 153, 194, 0.08);
      border-bottom: 2px solid ${({ theme }) => theme.colors.primaryTextHover};
    }

    &:focus {
      color: ${({ theme }) => theme.colors.neutralsText};
    }

    ${({ error }) =>
      error &&
      css`
        border-bottom: 2px solid ${({ theme }) => theme.colors.offTrackText} !important;
      `}
  }

  > span.error {
    display: block;
    height: 12px;
    ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
    color: ${({ theme }) => theme.colors.offTrackText};
    padding-top: 4px;
  }
`;
